export class Chat {
    constructor(public message?: string) {
    }
}